<template>
    <div>
        <head-banner :title="shop.name" />
        <div class="b_shop_subcategory">
            <tags
                :tags="tags"
                :selected="selectedTag"
                @tag-clicked="onTagClicked"
            />

            <div class="page_control">
                <div class="container">
                    <nuxt-link
                        to="#"
                        class="btn_link second_font"
                        @click.native="onBackToShops"
                    >
                        לחנויות
                    </nuxt-link>
                </div>
            </div>

            <div class="subcategory_wrapper">
                <div class="container">
                    <div class="buttons_wrapper">
                        <div class="buttons flex">
                            <div class="btn_item">
                                <button
                                    class="btn btn_green_empty btn_filter"
                                    type="button"
                                    @click="toggleFilters"
                                >
                                    סינון
                                </button>
                            </div>
                            <div class="btn_item">
                                <nuxt-link
                                    tag="button"
                                    to="/checkout/order"
                                    class="btn btn_template btn_basket"
                                    :disabled="isCartEmpty"
                                >
                                    לסל
                                </nuxt-link>
                            </div>
                        </div>
                    </div>
                    <div class="subcategory_block flex">
                        <filters
                            :filters="filters"
                            :active="activeFilters"
                            :total="total"
                            @filters-changed="onFiltersChanged"
                            @close-filters="toggleFilters"
                        />

                        <products
                            :products="products"
                            :total="total"
                            @get-more="fetchProducts(true)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <different-shop-modal @accepted="onDifferentShopAccept" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { StatusCodes } from 'http-status-codes';
import headMixin from '@/mixins/head.mixin.js';
import Tags from '@/components/shops-common/Tags';
import Filters from '@/components/shops-common/Filters';
import Products from '@/components/shops-common/Products';
import HeadBanner from '@/components/elements/HeadBanner';
import DifferentShopModal from '@/components/modals/DifferentShop';

export default {
    components: {
        Tags,
        Filters,
        Products,
        HeadBanner,
        DifferentShopModal
    },

    mixins: [headMixin],

    async asyncData({ params: { slug }, store: { dispatch }, error }) {
        try {
            const shop = await dispatch('shops/show', slug);

            const page = 1;
            const perPage = 9;

            const [
                { rows: tags },
                { rows: products, count: total },
                filters
            ] = await Promise.all([
                dispatch('shops/getTags', shop.id),
                dispatch('shops/getProducts', { id: shop.id, page, perPage }),
                dispatch('shops/getFilters', shop.id)
            ]);

            return {
                shop,
                tags,
                products,
                total,
                page,
                perPage,
                filters,
                selectedTag: null,
                activeFilters: {},
                meta: shop.meta
            };
        } catch (err) {
            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    computed: {
        ...mapGetters({
            items: 'cart/items',
            currentShopId: 'cart/currentShopId'
        }),

        isCartEmpty() {
            return !this.items.length;
        }
    },

    methods: {
        ...mapActions({
            getProducts: 'shops/getProducts',
            initJQuery: 'scripts/initJQuery'
        }),

        async fetchProducts(getMore = false) {
            try {
                this.page = getMore ? this.page + 1 : 1;

                const params = {
                    id: this.shop.id,
                    page: this.page,
                    perPage: this.perPage,
                    attributes: this.activeFilters
                };

                if (this.selectedTag) {
                    const filters = {
                        'tags.name': {
                            value: this.selectedTag.name,
                            type: 'substring'
                        }
                    };

                    params.filters = filters;
                }

                const { count, rows } = await this.getProducts(params);

                this.total = count;

                this.products = getMore ? [...this.products, ...rows] : rows;
            } catch (error) {
                console.error(error);
            }
        },

        onBackToShops() {
            if (this.shop.id === this.currentShopId) {
                this.$openModal('differentShop');

                return;
            }

            this.$router.push('/shops');
        },

        onDifferentShopAccept() {
            this.$router.push('/shops');
        },

        onTagClicked(tag) {
            this.selectedTag = tag;

            this.fetchProducts();
        },

        onFiltersChanged(filters) {
            this.activeFilters = { ...filters };

            this.fetchProducts();
        },

        toggleFilters() {
            this.initJQuery();

            const $ = window.jQuery;

            $('.filter_wrapper').fadeToggle(200);
        }
    }
};
</script>
